import SeoPageLayout from "@/components/SeoPageLayout";

const StandUpNaEvent = () => (
  <SeoPageLayout title="Stand-up na event - nowoczesna komedia na Twoje wydarzenie">
    <p>
      Stand-up comedy to jedna z najdynamiczniej rozwijających się form rozrywki w Polsce. Stand-up na event firmowy to świeże, nowoczesne podejście do rozrywki korporacyjnej, które trafia w gusta młodszych pokoleń pracowników, nie tracąc przy tym uniwersalności przekazu.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Czym różni się stand-up od klasycznego kabaretu?</h2>
    <p>
      Stand-up to występ jednego komika, który prowadzi monolog humorystyczny, nawiązując bezpośredni kontakt z publicznością. W odróżnieniu od kabaretu, stand-up jest bardziej spontaniczny, personalny i oparty na autentycznych obserwacjach. To format idealny na mniejsze, kameralne wydarzenia.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kiedy wybrać stand-up zamiast kabaretu?</h2>
    <ul className="list-disc pl-6 space-y-2">
      <li>Na kameralnych spotkaniach do 100-150 osób</li>
      <li>Gdy publiczność jest młodsza i otwarta na nowoczesne formy humoru</li>
      <li>Na wydarzeniach w stylu afterwork lub casual</li>
      <li>Gdy zależy Ci na bezpośrednim kontakcie komika z publicznością</li>
      <li>Na eventach w restauracjach, pubach czy przestrzeniach coworkingowych</li>
    </ul>

    <h2 className="text-2xl font-bold text-foreground mt-10">Stand-up korporacyjny - humor dopasowany do biznesu</h2>
    <p>
      Stand-up na event firmowy to nie to samo co występ w klubie komediowym. Nasi komicy doskonale znają różnicę między sceną klubową a sceną korporacyjną. Materiał jest profesjonalny, elegancki i dopasowany do kontekstu biznesowego - bez wulgarności, ale z zachowaniem autentyczności i lekkości.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Jak wygląda stand-up na evencie firmowym?</h2>
    <p>
      Typowy stand-up na evencie trwa 20-40 minut. Komik rozpoczyna od uniwersalnych tematów, stopniowo przechodząc do obserwacji związanych z branżą lub firmą. Często wchodzi w interakcję z publicznością, co sprawia, że każdy występ jest unikalny i niepowtarzalny.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Zamów stand-up na swój event</h2>
    <p>
      Dysponujemy szerokim gronem profesjonalnych stand-uperów o różnych stylach komediowych. Pomożemy dobrać artystę idealnie pasującego do charakteru Twojego wydarzenia. Skontaktuj się z nami - doradzimy i przygotujemy ofertę.
    </p>
  </SeoPageLayout>
);

export default StandUpNaEvent;
